export type YouTubeCommand = 'playVideo' | 'pauseVideo' | 'mute' | 'unMute';

/** Extract an 11-char YouTube video ID from a Shorts URL or raw ID. */
export function parseYouTubeVideoId(urlOrId: string): string {
  const trimmed = urlOrId.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
    return trimmed;
  }

  const patterns = [
    /(?:shorts\/)([a-zA-Z0-9_-]{11})/,
    /(?:v=)([a-zA-Z0-9_-]{11})/,
    /(?:embed\/)([a-zA-Z0-9_-]{11})/,
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return trimmed;
}

export function buildYouTubeEmbedUrl(videoId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const params = new URLSearchParams({
    enablejsapi: '1',
    mute: '1',
    autoplay: '0',
    playsinline: '1',
    controls: '0',
    rel: '0',
    modestbranding: '1',
    loop: '1',
    playlist: videoId,
  });

  if (origin) {
    params.set('origin', origin);
  }

  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
}

export function sendYouTubeCommand(
  iframe: HTMLIFrameElement | null,
  command: YouTubeCommand
): void {
  if (!iframe?.contentWindow) {
    return;
  }

  iframe.contentWindow.postMessage(
    JSON.stringify({ event: 'command', func: command, args: '' }),
    '*'
  );
}
